var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopHeaderCurve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1726,
    height: 219,
    viewBox: "0 0 1726 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M548.15 205.74C191.586 250.897 -45.2278 167.357 -81.219 153.541C-84.228 152.386 -85.9999 149.551 -85.9999 146.328V8.76033C-85.9999 4.35777 -82.4426 0.782593 -78.0402 0.760422L1849.72 -8.94321C1855.23 -8.97096 1859.12 -3.54626 1857.32 1.66487L1789.06 199.599C1787.83 203.178 1784.17 205.39 1780.41 204.92C1198.67 132.148 896.431 161.632 548.15 205.74Z",
    fill: "#211452",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopHeaderCurve);
export default __webpack_public_path__ + "static/media/topHeaderCurve.374cc6129c5cbf0fce4256bbb79e133e.svg";
export { ForwardRef as ReactComponent };